export default "__VITE_ASSET__BA_9CPri__"